import { createSlice } from "@reduxjs/toolkit";
import { reducerRegistry } from "@/utils/redux";
import { initialState, reducers } from "./reducers";

const slice = createSlice({
  name: "CheckoutDeliveryInfo",
  initialState,
  reducers,
});

export const { actions, reducer } = slice;
export const {
  getCheckoutDeliveryInfo,
  getCheckoutDeliveryInfoError,
  getCheckoutDeliveryInfoSuccess,
} = slice.actions;

reducerRegistry.register("checkoutDeliveryInfo", reducer);
